<div *ngIf="statusCheck == 'employeeSearch'">
<div class="cardLayout">
  <ion-row>
    <ion-col size="12">
      <div class="popup-heading">
        <div class="verticle-center">
          <p class="fs-16 font_regular">Employee Search</p>
          <mat-form-field class="mat-height40 mat-input-style pl-10">
            <mat-icon matPrefix>search</mat-icon>
            <input matInput type="search" placeholder="Search" [(ngModel)]="searchEmployee"
                (input)="onEmployeeSearch(searchEmployee)">
          </mat-form-field>
         </div>
         <div class="popup-close">
          <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
        </div>
      </div>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="12"> 
      <div class="table-container mt-20">
      <table class="table">
        <thead>
          <tr>
            <th>Employee_Name</th>
            <th>Employee_Code</th>
            <th>Date_Of_Joining</th>
            <th>Official_Email</th>
            <th>Reporting Manager Name</th>
            <th>Designation</th>
            <th>Department</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of getEmployeeSearchData">
            <td>{{data.firstName}} {{data.lastName}}</td>
            <td>{{data.empCode}}</td>
            <td>{{data.dateOfJoining | date: 'dd-MM-yyyy'}}</td>
            <td>{{data.email}}</td>
            <td>{{data.reportingManagerName}}</td>
            <td>{{data.designation}}</td>
            <td>{{data.department}}</td>
          </tr>
        </tbody>
      </table>
      </div>
    </ion-col>
  </ion-row>
</div>
</div>

<div *ngIf="statusCheck == 'helpDesk'">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="12">
        <div class="popup-heading">
          <div>
            <p class="fs-16 font_regular">What Do You Want to View?</p>
           </div>
           <div class="popup-close">
            <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
        <div class="helpDeskcardBox">
          <div>
            <div><img src="././assets/icon/TicketingIcon.svg" alt=""></div>
            <div><button type="button" (click)="onClickOpenTickets()">Ticketing</button></div>
          </div>
        </div>
      </ion-col>
  
      <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
        <div class="helpDeskcardBox">
          <div>
            <div><img src="././assets/icon/userManualIcon.svg" alt=""></div>
            <div class="verticle-center" style="gap: 10px;">
              <span class="w-100" *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
                <button type="button" (click)="onClickShowUploadUserManual()">Upload Manual</button>
              </span>
              <span class="w-100">
              <button type="button" (click)="downloadUserManual()">Download Manual</button>
              </span>
            </div>
          </div>
        </div>
      </ion-col>
  
      <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
        <div class="helpDeskcardBox">
          <div>
            <div><img src="././assets/icon/VideosIcon.svg" alt=""></div>
            <div><button type="button">DIY Videos</button></div>
          </div>
        </div>
      </ion-col>
    </ion-row>
    
    <div *ngIf="isShowUploadUserManual">
      <ion-row>
        <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
          <div class="cardBox mt-10">
            <div *ngIf="!showBrowseBtn" class="upload-box display-center mt-5 cp" (click)="browseImage.click()">
              <div class="upload-file-container">
                <input #browseImage type="file" (change)="onFileSelected($event)" style="display:none;">       
                <div class="cp text-center font_regular mr-15">
                  <span class="material-icons fs-18">upload_file</span>
                  <div class="fs-12 text_blue" ><u>User Manual upload</u></div>
                </div>
  
              </div>
            </div>
            <div *ngIf="showBrowseBtn" class="w-100 upload-file-container display-center mt-20 cp">
              <div class="d-flex mb-20 mt-20">
                <div class="verticle-center mr-20">
                  <img src="././assets/icon/successImport.svg">
                </div>
                <div class="flex-column">
                  <label class="fs-14 font_medium text_gray1 mb-10">File Uploaded Successfully.</label>
                  <div class="d-flex">
                    <label class="fs-12 blue font_medium cl-black mx-width">{{fileName}}</label>
                    <span class="material-icons fs-12" (click)="onCloseFile()">close</span>
                  </div>
                </div>
              </div>
          </div>
          <div class="upload-file-validation">
            <p>file format</p>
            <button (click)="onClickSaveUserManualFile()" [disabled]="isDisabledUploadPolicyBtn">Save</button>
        </div>
        </div>
        </ion-col>
      </ion-row>
    </div>
  </div> 
</div>
 
<div *ngIf="statusCheck == 'hrHandBook'">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 font_regular">HR HandBook</p>
            <mat-form-field class="mat-height40 mat-input-style pl-10">
              <mat-icon matPrefix>search</mat-icon>
              <input matInput type="search" placeholder="Search" [(ngModel)]="searchEmployee"
                  (input)="onHandbookFileSearch(searchEmployee)">
            </mat-form-field>
           </div>
           <div class="popup-close">
            <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col  size="12">
        <div><p class="fs-14 font_semibold">Attached Files</p></div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <div class="cardBox">
          <div class="attached-files-container">
            <div class="file-card">
              <div *ngFor="let data of handbookFileData; let i = index" class="file-row">
                <div class="file-info">
                  <img class="w-40 mr-20" src="././assets/icon/PDFfileIcon.svg" alt="">
                  <a class="fileName">{{ data.handbookFileName }}</a>
                </div>
                <div class="file-actions-icon">
                  <button mat-icon-button (click)="viewHandBookFile(data.handbookUrl, data.handbookFileName)">
                    <span class="material-icons viewIcon">visibility</span>
                    </button>
                  <button mat-icon-button (click)="downloadHandBookFile(data.handbookUrl, data.handbookFileName)">
                    <span class="material-icons" >download</span>
                  </button>
                  <button mat-icon-button (click)="onClickDeleteHandbookFile(data.id)" *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
                    <span class="material-icons">close</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ion-col>
    </ion-row>
  
    <ion-row>
      <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
        <!-- <div class="cardBox">
          <div>
            <button class="letter-head-download-btn" (click)="triggerFileInput()">
              Upload New File
            </button>
          </div>
              <div class="upload-file-container">
                <ion-content>
                  <input type="file" (change)="onFileSelected($event)" id="fileInput" hidden/>
                  <div class="cp text-center font_regular mr-15">
                    <span class="material-icons fs-18" (click)="triggerFileInput()">upload_file</span>
                    <div class="fs-12 text_blue" ><u>letter head upload</u></div>
                  </div>
              </ion-content>
              </div>
          <div class="upload-file-validation">
              <p>supported file format - png/jpeg/jpg/pdf.</p>
              <button>Save</button>
          </div>
        </div> -->

        <div class="cardBox mt-10" *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
          <div *ngIf="!showBrowseBtn" class="upload-box display-center mt-5 cp" (click)="browseImage.click()">
            <div class="upload-file-container">
              <input #browseImage type="file" (change)="onFileSelected($event)" style="display:none;">       
              <div class="cp text-center font_regular mr-15">
                <span class="material-icons fs-18">upload_file</span>
                <div class="fs-12 text_blue" ><u>HR Handbook upload</u></div>
              </div>

            </div>
          </div>
          <div *ngIf="showBrowseBtn" class="w-100 upload-file-container display-center mt-20 cp">
            <div class="d-flex mb-20 mt-20">
              <div class="verticle-center mr-20">
                <img src="././assets/icon/successImport.svg">
              </div>
              <div class="flex-column">
                <label class="fs-14 font_medium text_gray1 mb-10">File Uploaded Successfully.</label>
                <div class="d-flex">
                  <label class="fs-12 blue font_medium cl-black mx-width">{{fileName}}</label>
                  <span class="material-icons fs-12" (click)="onCloseFile()">close</span>
                </div>
              </div>
            </div>
        </div>
        <div class="upload-file-validation">
          <p>supported file format - png/jpeg/jpg/xlsx/pdf.</p>
          <button (click)="onClickSaveHrHandbookFile()" [disabled]="isDisabledUploadPolicyBtn">Save</button>
      </div>
      </div>
      </ion-col>
    </ion-row>
  </div>  
</div>